
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3A4249","d":"M23.686 48.833L23 48.735V54a2.5 2.5 0 105 0v-2.982l-3.087-1.763a3.405 3.405 0 00-1.227-.422zM44.4 37.4l-2.084-2.083a5.463 5.463 0 01-1.554-3.164L37.64 7.959a5.687 5.687 0 00-11.28 0l-3.122 24.194a5.463 5.463 0 01-1.554 3.164L19.6 37.4a5.462 5.462 0 003.089 9.27l1.279.183c.681.097 1.34.322 1.937.665l3.385 1.933a5.46 5.46 0 005.42 0l3.385-1.933a5.427 5.427 0 011.937-.665l1.279-.183A5.462 5.462 0 0044.4 37.4zM39 51s-3 4.239-3 7 1.343 4 3 4 3-1.239 3-4-3-7-3-7z"}})])
          )
        }
      }
    